import React, { Component } from 'react';

import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Input,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Switch,
  Typography
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ElementoApi from '../../api/ElementoApi';
import { withAuditoria } from '../../contexts/AuditoriaContext';
import { withLoading } from '../../contexts/LoadingContext';
import { withSnackbar } from '../../contexts/SnackbarContext';
import AlertDialogSlide from './AlertDialogSlide';
import NadaEncontrado from './NadaEncontrado';
import AlertDialogSlideGlosa from './AlertDialogSlideGlosa';
import Elemento from './Elemento';
import LinearProgressBlockScreen from './LinearProgressBlockScreen';
import Paginacao from './Paginacao';

import SearchIcon from '@material-ui/icons/Search';
import ThumbDownIcon from '@material-ui/icons/ThumbDownAltOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUpAltOutlined';

import { parse } from 'date-fns';

const styles = theme => ({
  root: {
    display: 'block',
    overflow: 'auto',
    maxHeight: '88vh',
    margin: theme.spacing(1)
  },
  appBar: {
    zIndex: 1090,
    padding: theme.spacing(1),
    position: 'sticky',
    top: 0
  },
  elementosContainer: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    position: 'relative',
    top: theme.spacing(1),
    overflow: 'hidden'
  },
  buttonNegarEmLote: {
    flex: 1,
    paddingRight: '8px',
    backgroundColor: 'rgb(242, 222, 222)',
    border: '1px solid rgb(187, 136, 136)',
    '&:hover': {
      border: '1px solid grey',
    },
  },
  buttonAprovarEmLote: {
    flex: 1,
    paddingRight: '8px',
    marginLeft: theme.spacing(1),
    backgroundColor: 'rgb(223, 240, 216)',
    border: '1px solid #ABCCAB',
    '&:hover': {
      border: '1px solid grey',
    },
  },
  selectOrderBy: {
    margin: theme.spacing(1.5),
    width: 120,
    maxHeight: theme.spacing(2.3),
  },
  selectItensPorPagina: {
    margin: theme.spacing(1.5),
    width: 60,
    maxHeight: theme.spacing(2.3),
  },
  dividerFullWidth: {
    margin: `5px 0 0 ${theme.spacing(2)}px`,
  }
});

class PainelElementos extends Component {
  elementoApi = new ElementoApi();

  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      checkedTodos: false,
      checkedComGlosa: false,
      checkedProc: true,
      checkedDesp: true,
      checkedOpme: true,
      filtroElementos: '',
      filtroTabela: '',
      currentPage: 0,
      elementosPerPage: 10,
      elementos: this.props.elementos,
      elementosFiltrados: this.props.elementos,
      elementosSelecionados: [],
      indExisteAlgumSelecionado: false,
      openDialogNegarEmLote: false,
      openDialogAprovarEmLote: false,
      openDialogGlosaElemento: false,
      dialogTitleNegarEmLote: 'Negar elementos em lote',
      dialogTitleAprovarEmLote: 'Aprovar elementos em lote',
      dialogMessageNegarEmLote: '',
      dialogMessageAprovarEmLote: '',
      orderBy: 'codItem'
    };
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.elementos !== prevProps.elementos) {
      this.setState({ elementos: this.props.elementos });
    }
  }

  handleChangePage = (event, pageNumber) => {
    this.setState({ currentPage: pageNumber });
  }

  handleChangeFilterElementos = name => (event) => {
    const inputValue = event.target.value.replace(/[^a-zA-Zà-úÀ-Ú0-9\s]/g, '').toUpperCase();
    this.setState({ [name]: inputValue });
  }

  handleChangeChecked = name => (event) => {
    this.setState({ [name]: event.target.checked });
  }

  handleChangeValue = name => (event) => {
    this.setState({ [name]: event.target.value });
  }

  _haGlosa(elemento) {
    const { valTotalSolicitado, valTotalAutorizado } = elemento;

    const haGlosa =
      (valTotalAutorizado === null) ||
      (valTotalAutorizado === 0) ||
      (valTotalAutorizado !== null && valTotalAutorizado.toFixed(2) < valTotalSolicitado && valTotalAutorizado !== valTotalSolicitado);

    return haGlosa;
  }

  handleMarcarComoChecked = elementosFiltrados => (elemento) => {
    let novosElementosSelecionados = this.state.elementosSelecionados;
    const idx = novosElementosSelecionados.findIndex(el => el.id === elemento.id);

    if (idx === -1) {
      novosElementosSelecionados.push(elemento);
    } else {
      novosElementosSelecionados.splice(idx, 1);
    }

    this.setState({
      checkedTodos: novosElementosSelecionados.length === elementosFiltrados.length && elementosFiltrados.length > 0,
      elementosSelecionados: novosElementosSelecionados,
      indExisteAlgumSelecionado: novosElementosSelecionados.length > 0
    });
  }

  handleMarcarTodosComoChecked = elementosFiltrados => (event) => {
    const checked = event.target.checked;

    let novosElementosSelecionados = [];

    if (checked) {
      novosElementosSelecionados = elementosFiltrados;
    }

    this.setState({
      checkedTodos: checked,
      elementosSelecionados: novosElementosSelecionados,
      indExisteAlgumSelecionado: novosElementosSelecionados.length > 0
    });
  }

  handleClickNegarEmLote = () => {
    const cont = this.state.elementosSelecionados.length;
    this.setState({
      openDialogNegarEmLote: true,
      dialogMessageNegarEmLote: `Deseja negar em lote os ${cont} item(ns) selecionado(s)? 
      O valor unitário, quantidade e percentual de redução e acréscimo autorizados serão zerados. 
      Favor escolher um motivo de glosa.`
    });
  }

    handleCloseDialogNegarEmLote = () => {
      this.setState({ openDialogNegarEmLote: false });
    }
  
    handleDialogConfirmNegarEmLote = () => {
      this.setState({ openDialogNegarEmLote: false, openDialogGlosaElemento: true });
    }

    handleClickAprovarEmLote = () => {
      const cont = this.state.elementosSelecionados.length;
      this.setState({
        openDialogAprovarEmLote: true,
        dialogMessageAprovarEmLote: `Deseja aprovar em lote os ${cont} item(ns) selecionado(s)? 
        O valor unitário, quantidade e percentual de redução e acréscimo serão autorizados.`
      });
    }

    handleCloseDialogAprovarEmLote = () => {
      this.setState({ openDialogAprovarEmLote: false });
    }
  
    handleConfirmDialogAprovarEmLote = async () => {
      this.setState({ openDialogAprovarEmLote: false });

      this.props.showLoading('Salvando...');

      const elementosSelecionadosParaAprovacao = this.state.elementosSelecionados.map(elemento => {
        const newElemento = {
          ...elemento,
          glosas: [],
          qtdAutorizada: elemento.qtdSolicitada,
          valUnitarioAutorizado: elemento.valUnitarioSolicitado,
          valPctReducaoAcrescimoAutorizado: elemento.valPctReducaoAcrescimoSolicitado || 1,
          valTotalAutorizado: elemento.indReapresentacao !== 'S'
            ? elemento.valTotalSolicitado
            : this._roundUp((elemento.qtdSolicitada *
              elemento.valUnitarioSolicitado *
              elemento.valPctReducaoAcrescimoSolicitado || 1) - elemento.elementoOriginalDTO.valTotalAutorizado, 3),
          dtaRealizacao: parse(elemento.dtaRealizacao)
        };
        return newElemento;
      });

      let results = [];
      for (const elemento of elementosSelecionadosParaAprovacao) {
        const response = await this.elementoApi.salvarAuditoriaElemento(this.props.loteSelecionado.codLote, elemento);
        results.push(response.data);
      };

      this.props.hideLoading();

      results.forEach(result => {
        if (result.codigoRetorno === 1) {
          this.props.showSnackbar(result.msgRetornoResumida, 'success', 4000, '', null, 'bottom');
        } else {
          this.props.showSnackbar(result.msgRetornoResumida, 'error', 4000, '', null, 'bottom');
        }
      });

      const allSuccess = results.every(result => result.codigoRetorno === 1);

      if (allSuccess) {
        this.setState({ 
          checkedTodos: false,
          elementosSelecionados: [],
          indExisteAlgumSelecionado: false
        });
        
        this.props.onOperacaoRealizada();
        this.props.showSnackbar('Operação realizada com sucesso', 'success', 4000, '', null, 'bottom');
      }
    }
  
    handleCloseDialogGlosaElemento = () => {
      this.setState({ openDialogGlosaElemento: false });
    }

  handleConfirmDialogGlosaElemento = async (codMensagemGlosa, desMensagemGlosa, desObservacao) => {
    // console.log(codMensagemGlosa, desMensagemGlosa, desObservacao);

    this.props.showLoading('Salvando...');

    const elementosSelecionadosParaGlosa = this.state.elementosSelecionados.map(elemento => {
      let glosas = [{
        codItemPai: elemento.id,
        codMensagemGlosa: codMensagemGlosa,
        desMensagemGlosa: desMensagemGlosa,
        txtObservacao: desObservacao || ''
      }];

      elemento = {
        ...elemento,
        glosas: glosas,
        qtdAutorizada: 0,
        valUnitarioAutorizado: 0,
        valPctReducaoAcrescimoAutorizado: 0,
        valTotalAutorizado: 0,
        dtaRealizacao: parse(elemento.dtaRealizacao)
      };
      return elemento;
    });

    let results = [];
    for (const elemento of elementosSelecionadosParaGlosa) {
      const response = await this.elementoApi.salvarAuditoriaElemento(this.props.loteSelecionado.codLote, elemento);
      results.push(response.data);
    };

    this.props.hideLoading();

    results.forEach(result => {
      if (result.codigoRetorno === 1) {
        this.props.showSnackbar(result.msgRetornoResumida, 'success', 4000, '', null, 'bottom');
      } else {
        this.props.showSnackbar(result.msgRetornoResumida, 'error', 4000, '', null, 'bottom');
      }
    });

    const allSuccess = results.every(result => result.codigoRetorno === 1);

    if (allSuccess) {
      this.setState({ 
        checkedTodos: false,
        elementosSelecionados: [],
        indExisteAlgumSelecionado: false
      });

      this.props.onOperacaoRealizada();
      this.props.showSnackbar('Operação realizada com sucesso', 'success', 4000, '', null, 'bottom');
    }
    
    this.handleCloseDialogGlosaElemento();
  }

  onOperacaoRealizadaEmElemento = async () => {
    this.props.onOperacaoRealizada();
  }
  
  _roundUp = (num, precision) => {
    precision = Math.pow(10, precision);
    return Math.round(Number(num) * precision) / precision;
  }

  render() {
    const { classes, readOnly, elementos, emAuditoria, exibirFiltros } = this.props;
    const { currentPage, elementosPerPage, orderBy, filtroTabela, elementosSelecionados, indExisteAlgumSelecionado } = this.state;

    let tipoElementoGuiaAtual = 0;
    let mudouDeElemento = true;

    const indexOfLastElemento = currentPage * elementosPerPage + elementosPerPage;
    const indexOfFirstElemento = currentPage * elementosPerPage;

    const regexFiltroElementos = new RegExp(this.state.filtroElementos);

    const elementosFiltrados = this.state.elementos
      .filter(elemento =>
        (this.state.checkedDesp && elemento.tipoElementoGuia === 'OUTRA_DESPESA') ||
        (this.state.checkedProc && elemento.tipoElementoGuia === 'PROCEDIMENTO') ||
        (this.state.checkedOpme && elemento.tipoElementoGuia === 'OPME'))
      .filter(elemento => (this.state.checkedComGlosa && this._haGlosa(elemento)) || (!this.state.checkedComGlosa))
      .filter(elemento => {
        return (
          regexFiltroElementos.test(elemento.desItem.toUpperCase()) ||
          regexFiltroElementos.test(elemento.codItem.toUpperCase()) ||
          regexFiltroElementos.test(String(elemento.valUnitarioVigente).toUpperCase().replace('.', ',')));
      })
      .filter(elemento => (this.state.filtroTabela === '' || elemento.codTabela === this.state.filtroTabela));

    if (this.state.orderBy === 'codItem') {
      elementosFiltrados
        .sort((a, b) => {
          var aTipo = a.tipoElementoGuia;
          var bTipo = b.tipoElementoGuia;
          var aCodItem = a.codItem;
          var bCodItem = b.codItem;
          return (aTipo < bTipo) ? 1 : (aTipo > bTipo) ? -1 : (aCodItem - bCodItem);
        });
    }

    if (this.state.orderBy === 'valTotalSolicitado') {
      elementosFiltrados
        .sort((a, b) => {
          var aTipo = a.tipoElementoGuia;
          var bTipo = b.tipoElementoGuia;
          var aValTot = a.valTotalSolicitado;
          var bValTot = b.valTotalSolicitado;
          return (aTipo < bTipo) ? 1 : (aTipo > bTipo) ? -1 : (aValTot - bValTot);
        });
    }

    if (this.state.orderBy === 'desItem') {
      elementosFiltrados
        .sort((a, b) => {
          var aTipo = a.tipoElementoGuia;
          var bTipo = b.tipoElementoGuia;
          var aDesItem = a.desItem.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          var bDesItem = b.desItem.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
          return (aTipo < bTipo) ? 1 : (aTipo > bTipo) ? -1 : (aDesItem < bDesItem) ? -1 : (aDesItem > bDesItem) ? 1 : 0;
        });
    }

    return (
      elementos.length > 0
        ? <div className={classes.root}>

          {exibirFiltros ?
          <Paper elevation={0} className={classes.appBar}>
            <div className={classes.barraElementos} style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'row' }}>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={readOnly}
                        checked={this.state.checkedTodos}
                        onChange={this.handleMarcarTodosComoChecked(elementosFiltrados)}
                        value='checkedTodos'
                      />
                    }
                  />
                </FormGroup>
              </FormControl>
              <FormControl style={{ flex: 1, paddingRight: '8px' }}>
                <Input
                  fullWidth
                  type='search'
                  placeholder={'Descrição ou código do item...'}
                  value={this.state.filtroElementos}
                  disabled={indExisteAlgumSelecionado}
                  onChange={this.handleChangeFilterElementos('filtroElementos')}
                  startAdornment={<InputAdornment position='start'><SearchIcon /></InputAdornment>}
                />
              </FormControl>
              <FormControl component="fieldset">
                <FormGroup style={{ display: 'flex', justifyContent: 'flex-end', flexDirection: 'row' }}>
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        disabled={indExisteAlgumSelecionado}
                        checked={this.state.checkedComGlosa}
                        onChange={this.handleChangeChecked('checkedComGlosa')}
                        value='checkedComGlosa'
                      />
                    }
                    label='Com glosas'
                    localPlacement='top'
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        disabled={indExisteAlgumSelecionado || elementos.filter(elemento => elemento.tipoElementoGuia === 'PROCEDIMENTO').length === 0}
                        checked={this.state.checkedProc}
                        onChange={this.handleChangeChecked('checkedProc')}
                        value='checkedProc'
                      />
                    }
                    label='Procedimentos'
                    localPlacement='top'
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        disabled={indExisteAlgumSelecionado || elementos.filter(elemento => elemento.tipoElementoGuia === 'OUTRA_DESPESA').length === 0}
                        checked={this.state.checkedDesp}
                        onChange={this.handleChangeChecked('checkedDesp')}
                        value='checkedDesp'
                      />
                    }
                    label='Despesas'
                    localPlacement='top'
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        size="small"
                        disabled={indExisteAlgumSelecionado || elementos.filter(elemento => elemento.tipoElementoGuia === 'OPME').length === 0}
                        checked={this.state.checkedOpme}
                        onChange={this.handleChangeChecked('checkedOpme')}
                        value='checkedOpme'
                      />
                    }
                    label='OPMEs'
                    localPlacement='top'
                  />
                </FormGroup>
              </FormControl>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', rowGap: '8px', flexDirection: 'row' }}>
              {this.state.indExisteAlgumSelecionado && !this.props.readOnly?
                <>
                  <Button
                    color='secondary'
                    variant='outlined'
                    title='Negar Itens Selecionados em Lote'
                    type='submit'
                    onClick={this.handleClickNegarEmLote}
                    className={classes.buttonNegarEmLote}>
                    <ThumbDownIcon style = {{ marginRight: '8px'}} />
                    {`Negar ${elementosSelecionados.length} itens`}
                  </Button>
                  <Button
                    color='primary'
                    variant='outlined'
                    title='Aprovar Itens Selecionados em Lote'
                    type='submit'
                    onClick={this.handleClickAprovarEmLote}
                    className={classes.buttonAprovarEmLote}>
                      <ThumbUpIcon style={ {marginRight: '8px'} }/>
                    {`Aprovar ${elementosSelecionados.length} itens`}
                  </Button>
                </>
                : null}
              <Select
                className={classes.selectOrderBy}
                value={filtroTabela}
                displayEmpty
                disabled={indExisteAlgumSelecionado}
                onChange={this.handleChangeValue('filtroTabela')}
                inputProps={{
                  name: 'filtroTabela',
                }}
              >
                <MenuItem key={0} value={''}>Tabela</MenuItem>
                <MenuItem key={1} value={12}>SIMPRO</MenuItem>
                <MenuItem key={2} value={5}>BRASINDICE</MenuItem>
                <MenuItem key={3} value={16}>TUSS</MenuItem>
                <MenuItem key={4} value={504}>CNU</MenuItem>
                <MenuItem key={5} value={94}>TST-SAÚDE</MenuItem>
                <MenuItem key={7} value={10}>SUS AMBULATORIAL</MenuItem>;
                <MenuItem key={6} value={11}>SUS HOSPITALAR</MenuItem>;
              </Select>
              <Select
                className={classes.selectOrderBy}
                value={orderBy}
                disabled={indExisteAlgumSelecionado}
                onChange={this.handleChangeValue('orderBy')}
                inputProps={{
                  name: 'orderBy',
                }}
              >
                <MenuItem key={1} value={'codItem'}>Código</MenuItem>
                <MenuItem key={2} value={'desItem'}>Descrição</MenuItem>
                <MenuItem key={3} value={'valTotalSolicitado'}>Val. Solic.</MenuItem>
              </Select>
              <Select
                className={classes.selectItensPorPagina}
                value={elementosPerPage}
                onChange={this.handleChangeValue('elementosPerPage')}
                inputProps={{
                  name: 'elementosPerPage',
                }}
              >
                <MenuItem key={1} value={10}>10</MenuItem>
                <MenuItem key={2} value={50}>50</MenuItem>
                <MenuItem key={3} value={100}>100</MenuItem>
              </Select>
              <Paginacao
                rowsPerPageOptions={[elementosPerPage]}
                rowsPerPage={elementosPerPage}
                count={elementosFiltrados.length || 0}
                currentPage={currentPage}
                paginate={this.handleChangePage} />
            </div>
          </Paper>
          : null
          }

          <div className={classes.elementosContainer}>
            {this.state.fetching ? <LinearProgressBlockScreen />
              : elementosFiltrados.length > 0
                ? elementosFiltrados
                  .slice(indexOfFirstElemento, indexOfLastElemento)
                  .map((elemento, idx) => {
                    mudouDeElemento = tipoElementoGuiaAtual !== elemento.tipoElementoGuia;
                    tipoElementoGuiaAtual = elemento.tipoElementoGuia;
                    return (
                      <>
                        {mudouDeElemento || idx === 0 ?
                          <>
                            {/* <Divider className={classes.dividerFullWidth} /> */}
                            <Typography
                              className={classes.dividerInset}
                              color="textSecondary"
                              display="block"
                              variant="caption"
                            >
                              {this.state.checkedDesp && elemento.tipoElementoGuia === 'OUTRA_DESPESA' ? 'DESPESAS' : ''}
                              {this.state.checkedProc && elemento.tipoElementoGuia === 'PROCEDIMENTO' ? 'PROCEDIMENTOS' : ''}
                              {this.state.checkedOpme && elemento.tipoElementoGuia === 'OPME' ? 'OPMEs' : ''}
                            </Typography>
                          </> : null}
                        <Elemento
                          key={idx}
                          idx={idx}
                          elemento={elemento}
                          onOperacaoRealizada={this.onOperacaoRealizadaEmElemento}
                          emAuditoria={emAuditoria}
                          readOnly={readOnly}
                          isGuiaSolicitacao={this.props.isGuiaSolicitacao}
                          elementosDaGuia={elementos}
                          isSelecionado={elementosSelecionados.findIndex(el => el.id === elemento.id) === -1 ? false : true}
                          selecionarElemento={this.handleMarcarComoChecked(elementosFiltrados)}
                        />
                      </>
                    );
                  })
                : <NadaEncontrado mensagem={'Não foram encontrados itens para esse filtro'} />}
          </div>

          <AlertDialogSlide
            open={this.state.openDialogNegarEmLote}
            handleClose={this.handleCloseDialogNegarEmLote}
            handleClick={this.handleDialogConfirmNegarEmLote}
            title={this.state.dialogTitleNegarEmLote}
            message={this.state.dialogMessageNegarEmLote} />

          <AlertDialogSlide
            open={this.state.openDialogAprovarEmLote}
            handleClose={this.handleCloseDialogAprovarEmLote}
            handleClick={this.handleConfirmDialogAprovarEmLote}
            title={this.state.dialogTitleAprovarEmLote}
            message={this.state.dialogMessageAprovarEmLote} />

          <AlertDialogSlideGlosa
            open={this.state.openDialogGlosaElemento}
            handleClose={this.handleCloseDialogGlosaElemento}
            handleClickIncluirGlosa={this.handleConfirmDialogGlosaElemento}
            title={'Adicionar motivo de glosa do item'}
            message={''} />
        </div>
        : null
    );
  }
}

export default withAuditoria(withSnackbar(withLoading(withStyles(styles)(PainelElementos))));
